import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SAPMATERIALTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('sapCode', 'Entity.SapMaterialType.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('description', 'Entity.SapMaterialType.Description')
    .maxLength(100)
    .build(),
];

export const SAPMATERIALTYPE_CONFIG = {
  entityName: 'SapMaterialType',
  localizationKey: 'Controlling::Entity.SapMaterialType',
  fields: SAPMATERIALTYPE_FIELDS,
  permission: 'ControllingSap.SapMaterialTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
